var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9323 5.33155C34.9474 5.25781 35.0527 5.25781 35.0678 5.33155C35.8501 9.15894 38.8412 12.15 42.6686 12.9323C42.7423 12.9474 42.7423 13.0527 42.6686 13.0678C38.8412 13.8501 35.8501 16.8412 35.0678 20.6686C35.0527 20.7423 34.9474 20.7423 34.9323 20.6686C34.15 16.8412 31.1589 13.8501 27.3316 13.0678C27.2578 13.0527 27.2578 12.9474 27.3316 12.9323C31.1589 12.15 34.15 9.15894 34.9323 5.33155Z",
    stroke: "#B3FF10",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4374 0.752147C43.5626 0.139909 44.4374 0.139909 44.5625 0.752148C44.8389 2.10434 45.8956 3.16106 47.2478 3.43744C47.86 3.56258 47.86 4.43735 47.2478 4.56249C45.8956 4.83887 44.8389 5.89559 44.5625 7.24778C44.4374 7.86002 43.5626 7.86002 43.4374 7.24778C43.1611 5.89559 42.1043 4.83887 40.7521 4.56249C40.1399 4.43735 40.1399 3.56258 40.7521 3.43744C42.1043 3.16106 43.1611 2.10434 43.4374 0.752147Z",
    fill: "#B3FF10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2305 13C21.4568 13.1298 20.7104 13.3398 20 13.6211C15.8999 15.2449 13 19.2455 13 23.9234C13 30.0409 17.9592 35 24.0766 35C28.7545 35 32.7551 32.1002 34.3789 28C34.6602 27.2896 34.8702 26.5432 35 25.7695M27.8 5.38007C26.5722 5.13083 25.3014 5 24 5C13.5066 5 5 13.5066 5 24C5 34.4934 13.5066 43 24 43C34.4934 43 43 34.4934 43 24C43 22.3598 42.7922 20.7682 42.4014 19.25M27.5 24C27.5 25.933 25.933 27.5 24 27.5C22.067 27.5 20.5 25.933 20.5 24C20.5 22.067 22.067 20.5 24 20.5C25.933 20.5 27.5 22.067 27.5 24Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.18d859471c3de77f0184991bc88995de.svg";
export { ForwardRef as ReactComponent };